

import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const SEARCH_EMPLOYEE_REQUEST = "SEARCH_EMPLOYEE_REQUEST";
export const SEARCH_EMPLOYEE_SUCCESS = "SEARCH_EMPLOYEE_SUCCESS";
export const SEARCH_EMPLOYEE_FAILURE = "SEARCH_EMPLOYEE_FAILURE";
export const CLEAR_EMPLOYEES = "CLEAR_EMPLOYEES";

// Search employees action
export const searchEmployee = (searchTerm) => async (dispatch) => {
  try {
    dispatch({ type: SEARCH_EMPLOYEE_REQUEST });

    const token = localStorage.getItem("token"); // Adjust if token stored elsewhere

    const response = await axios.get(
      `${BASE_URL}/v1/api/searchEmployee?search=${encodeURIComponent(searchTerm)}`,
      {
        headers: {
          authorization: token ? `${token}` : "",
        },
      }
    );

    dispatch({
      type: SEARCH_EMPLOYEE_SUCCESS,
      payload: response.data.data, // Assuming your API returns employees array in data.data
    });
  } catch (error) {
    dispatch({
      type: SEARCH_EMPLOYEE_FAILURE,
      payload:
        error.response?.data?.message || error.message || "Failed to fetch employees",
    });
  }
};

// Clear employees list (optional utility action)
export const clearEmployees = () => (dispatch) => {
  dispatch({ type: CLEAR_EMPLOYEES });
};



